"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unfollowCollection = exports.followCollection = exports.addOrRemoveEventToCollection = exports.deleteCollectionThunk = exports.editCollection = exports.createCollection = exports.getFollowedCollections = exports.getCollectionsForPlace = exports.getCollections = exports.deleteCollection = exports.updateCollectionEvents = exports.updateCollection = exports.setCollections = exports.clearCollections = void 0;

var _filter = _interopRequireDefault(require("lodash/filter"));

var _find = _interopRequireDefault(require("lodash/find"));

var _get = _interopRequireDefault(require("lodash/get"));

var _transformationUtils = require("@eb/transformation-utils");

var _api = require("./api");

var _actionTypes = require("./actionTypes");

var _analytics = require("./analytics");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var clearCollections = function clearCollections() {
  return {
    type: _actionTypes.CLEAR_COLLECTIONS
  };
};

exports.clearCollections = clearCollections;

var setCollections = function setCollections(data, customActionType) {
  return {
    type: customActionType || _actionTypes.SET_COLLECTIONS,
    payload: data
  };
};

exports.setCollections = setCollections;

var updateCollection = function updateCollection(data) {
  return {
    type: _actionTypes.UPDATE_COLLECTION,
    payload: data
  };
};

exports.updateCollection = updateCollection;

var updateCollectionEvents = function updateCollectionEvents(data) {
  return {
    type: _actionTypes.UPDATE_COLLECTION_EVENTS,
    payload: data
  };
};

exports.updateCollectionEvents = updateCollectionEvents;

var deleteCollection = function deleteCollection(id) {
  return {
    type: _actionTypes.DELETE_COLLECTION,
    payload: id
  };
};

exports.deleteCollection = deleteCollection;

var getCollections = function getCollections() {
  return function (dispatch, getState) {
    var _getState = getState(),
        publicId = _getState.user.publicId;

    return (0, _api.getUserCollections)(publicId).then(function (response) {
      return dispatch(setCollections((0, _utils.transformCollectionResponse)(response)));
    });
  };
};

exports.getCollections = getCollections;

var getCollectionsForPlace = function getCollectionsForPlace(_ref) {
  var placeId = _ref.placeId,
      collectionsToShow = _ref.collectionsToShow,
      customActionType = _ref.customActionType;
  return function (dispatch) {
    var queryCallback = function queryCallback(response) {
      var filteredEntities = [];
      filteredEntities = (0, _filter.default)(response.collections, function (collection) {
        return (0, _find.default)(collectionsToShow, function (collectionToShow) {
          return collectionToShow === collection.id;
        });
      });
      response.collections = filteredEntities;

      var _transformCollectionR = (0, _utils.transformCollectionResponse)(response),
          entities = _transformCollectionR.entities,
          hasMoreItems = _transformCollectionR.hasMoreItems,
          continuation = _transformCollectionR.continuation;

      dispatch(setCollections({
        entities: entities,
        hasMoreForPlace: hasMoreItems,
        continuationForPlace: continuation
      }, customActionType));
    };

    if (collectionsToShow) {
      if (placeId) {
        return (0, _api.getCollectionsForPlace)(placeId).then(queryCallback,
        /**
         * None calls were catching the errors and we don't have something to
         * do when the api fails right now besides failing so we silence the
         * error.
         */
        function () {});
      } else {
        return (0, _api.getCollectionsForOnline)().then(queryCallback,
        /**
         * None calls were catching the errors and we don't have something to
         * do when the api fails right now besides failing so we silence the
         * error.
         */
        function () {});
      }
    }
  };
};

exports.getCollectionsForPlace = getCollectionsForPlace;

var getFollowedCollections = function getFollowedCollections(userId) {
  var continuation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return function (dispatch) {
    return (0, _api.getFollowedCollections)(userId, continuation).then(function (response) {
      var _transformCollectionR2 = (0, _utils.transformCollectionResponse)(response),
          entities = _transformCollectionR2.entities,
          hasMoreItems = _transformCollectionR2.hasMoreItems,
          continuation = _transformCollectionR2.continuation;

      dispatch(setCollections({
        entities: entities,
        hasMoreFollowed: hasMoreItems,
        continuationFollowed: continuation
      }));
    });
  };
}; // At the moment client side only supports a single event to be hydrated
// into a created collection at a time. Backend supports multiple, but
// update will be needed to reducer code to support that.


exports.getFollowedCollections = getFollowedCollections;

var createCollection = function createCollection(category) {
  return function (collectionName) {
    var eventIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return function (dispatch, getState) {
      var _getState2 = getState(),
          gaSettings = _getState2.gaSettings;

      return (0, _api.createCollection)(collectionName, eventIds).then(function (_ref2) {
        var id = _ref2.id,
            collectionData = _objectWithoutProperties(_ref2, ["id"]);

        dispatch(setCollections({
          entities: _defineProperty({}, id, _objectSpread({
            id: id
          }, (0, _transformationUtils.deepKeysToCamel)(collectionData)))
        }));

        if (eventIds.length === 1) {
          dispatch(updateCollectionEvents({
            eventId: eventIds[0],
            shouldAdd: true,
            collectionId: id
          }));
        }

        if (category && gaSettings) {
          dispatch((0, _analytics.trackCreateCollection)(id, category));
        }

        return id;
      });
    };
  };
};

exports.createCollection = createCollection;

var editCollection = function editCollection(id, name) {
  return function (dispatch) {
    return (0, _api.editCollection)(id, name).then(function (response) {
      return dispatch(updateCollection((0, _transformationUtils.deepKeysToCamel)(response)));
    });
  };
};

exports.editCollection = editCollection;

var deleteCollectionThunk = function deleteCollectionThunk(id) {
  return function (dispatch) {
    return (0, _api.deleteCollection)(id).then(function () {
      return dispatch(deleteCollection(id));
    });
  };
};

exports.deleteCollectionThunk = deleteCollectionThunk;

var addOrRemoveEventToCollection = function addOrRemoveEventToCollection(category) {
  return function (_ref3) {
    var eventId = _ref3.eventId,
        onSave = _ref3.onSave,
        isChecked = _ref3.isChecked,
        value = _ref3.value;
    return function (dispatch, getState) {
      var _getState3 = getState(),
          gaSettings = _getState3.gaSettings; //TODO: Depending on how we handle the save/unsave event in relation to collections
      //this could change. For now, maintaining an abstracted version of the previous
      //behavior where this action will call the associated onSave action when appropriate
      //If approach varies we will need to


      if (value === 'saved') {
        return dispatch(onSave(eventId, isChecked));
      }

      var apiCall = _api.removeFromCollection;

      if (isChecked) {
        apiCall = _api.addToCollection;
      } //Optimistic state update


      dispatch(updateCollectionEvents({
        eventId: eventId,
        collectionId: value,
        shouldAdd: isChecked
      }));
      return apiCall(eventId, value).catch(function (error) {
        if (error === 'REACH_MAX_EVENTS') {
          dispatch((0, _analytics.trackMaxEventAdded)(value, category));
        }

        dispatch(updateCollectionEvents({
          eventId: eventId,
          collectionId: value,
          shouldAdd: !isChecked
        }));
        throw error;
      }).then(function () {
        if (category && gaSettings) {
          if (isChecked) {
            dispatch((0, _analytics.trackAddToCollection)(eventId, category));
          } else {
            dispatch((0, _analytics.trackRemoveFromCollection)(eventId, category));
          }
        }
      });
    };
  };
};

exports.addOrRemoveEventToCollection = addOrRemoveEventToCollection;

var followCollection = function followCollection(collectionId) {
  return function (dispatch, getState) {
    var _getState4 = getState(),
        _getState4$collection = _getState4.collections;

    _getState4$collection = _getState4$collection === void 0 ? {} : _getState4$collection;
    var _getState4$collection2 = _getState4$collection.entities,
        entities = _getState4$collection2 === void 0 ? {} : _getState4$collection2;
    return (0, _api.followCollection)(collectionId).then(function () {
      return dispatch(updateCollection({
        id: collectionId,
        followStatus: _objectSpread(_objectSpread({}, (0, _get.default)(entities, [collectionId, 'followStatus'], {})), {}, {
          followedByYou: true,

          /* Chance may be incorrect relative to server but
                  updating to provide user with immediate feedback on action.*/
          numFollowers: (0, _get.default)(entities, [collectionId, 'followStatus', 'numFollowers'], 0) + 1
        })
      }));
    });
  };
};

exports.followCollection = followCollection;

var unfollowCollection = function unfollowCollection(collectionId) {
  return function (dispatch, getState) {
    var _getState5 = getState(),
        _getState5$collection = _getState5.collections;

    _getState5$collection = _getState5$collection === void 0 ? {} : _getState5$collection;
    var _getState5$collection2 = _getState5$collection.entities,
        entities = _getState5$collection2 === void 0 ? {} : _getState5$collection2;
    return (0, _api.unfollowCollection)(collectionId).then(function () {
      return dispatch(updateCollection({
        id: collectionId,
        followStatus: _objectSpread(_objectSpread({}, (0, _get.default)(entities, [collectionId, 'followStatus'], {})), {}, {
          followedByYou: false,

          /* Chance may be incorrect relative to server but
                  updating to provide user with immediate feedback on action.*/
          numFollowers: (0, _get.default)(entities, [collectionId, 'followStatus', 'numFollowers'], 1) - 1
        })
      }));
    });
  };
};

exports.unfollowCollection = unfollowCollection;
//# sourceMappingURL=actions.js.map